import DropdownGroup, { DropdownGroupProps } from './DropdownGroup.component';

export type DropdownGroup = DropdownGroupProps;

export default DropdownGroup;
